// BrandLogo.jsx — shared SSS brand lockup (shield + wordmark + tagline).
// Generalized from field-services' MusterLogo so every SSS app uses the same
// login design — only the `word` changes per app (CRM / Inspections / ...).
//
// Requires:
//   - /brand-shield.png in client/public  (the orange SSS shield, transparent bg)
//   - Libre Franklin loaded in index.html <head>:
//       <link href="https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@500;800&display=swap" rel="stylesheet">

import React from 'react';

const DARK = '#0F0F0F'; // wordmark on light (SSS site dark)
const TAG  = '#555855'; // tagline on light (SSS site text)
const FONT = "'Libre Franklin', system-ui, -apple-system, Arial, sans-serif";

export default function BrandLogo({
  word = 'SSS',
  variant = 'horizontal',   // 'horizontal' | 'stacked'
  reverse = false,          // true when sitting on a dark surface
  size = 40,                // shield height in px
  wordSize,                 // optional explicit wordmark px (long words need this)
  showTagline = true,
  shieldSrc = '/brand-shield.png',
  style = {},
}) {
  const stacked = variant === 'stacked';
  const wordColor = reverse ? '#FFFFFF' : DARK;
  const tagColor  = reverse ? 'rgba(255,255,255,0.72)' : TAG;
  const wSize = wordSize || Math.round(size * 0.86);
  const tagSize = Math.max(11, Math.round(size * 0.27));

  return (
    <div style={{
      display: 'inline-flex',
      flexDirection: stacked ? 'column' : 'row',
      alignItems: 'center',
      gap: stacked ? Math.round(size * 0.18) : Math.round(size * 0.42),
      ...style,
    }}>
      <img
        src={shieldSrc}
        alt={word}
        height={size}
        style={{ height: size, width: 'auto', display: 'block', flex: 'none' }}
      />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: stacked ? 'center' : 'flex-start',
        lineHeight: 1,
      }}>
        <span style={{
          fontFamily: FONT,
          fontWeight: 800,
          fontSize: wSize,
          letterSpacing: '0.01em',
          color: wordColor,
          whiteSpace: 'nowrap',
        }}>{word}</span>
        {showTagline && (
          <span style={{
            fontFamily: FONT,
            fontWeight: 500,
            fontSize: tagSize,
            letterSpacing: '0.01em',
            color: tagColor,
            marginTop: Math.round(size * 0.12),
            whiteSpace: 'nowrap',
          }}>Integrity. Quality. Service.</span>
        )}
      </div>
    </div>
  );
}
